export const environment = {
  production: true,
  URL_BACK: 'https://as-eu2-prd-sig01-hegmcrdcftfhc0e0.eastus2-01.azurewebsites.net/api/v1/',
  BENEFICIARY_REPORT_VALIDATION_URL:'beneficiarios/validar',
  COMPROMISOS: 'https://as-eu2-dev-sipg-03-fga0a3h4bgahf5e2.eastus2-01.azurewebsites.net/',
  PASS_SITE_WEB: '6LfP8oUsAAAAAKoXJqEk5b9iwymiGsz4vXEY5Emp',
  SECRET_KEY: '6LeSgl8qAAAAAEv_WNmMuRe-YqWRvmn5kJU27mN-'
};
